import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from '@ngrx/store';

import { JobCreateCustomerActions } from 'src/app/job/job-create/job-create-customer/job-create-customer.actions';
import { NewOpportunityCustomerActions } from 'src/app/new-opportunity/new-opportunity-customer/new-opportunity-customer.actions';
import { LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunitySimilarJobsActions } from './new-opportunity-similar-jobs.actions';
import { NewOpportunitySimilarJobsState, newOpportunitySimilarJobsInitialState } from './new-opportunity-similar-jobs.state';

export const newOpportunitySimilarJobsReducers = [
    on(
      JobCreateCustomerActions.customerAutocompleteInputChanged,
      (state: NewOpportunitySimilarJobsState, { value, key }): NewOpportunitySimilarJobsState => {
        if (key === 'Tab' || key === 'Shift') {
            return state;
        }

        const query = value?.trim() ?? '';
        if (query.length > 0) {
            return state;
        }

        return {
            ...state,
            jobs: [],
            loading: LoadingState.INIT,
        }
      },
    ),
    on(
      NewOpportunitySimilarJobsActions.searchSimilarJobsStarted,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            loading: LoadingState.LOADING,
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.searchSimilarJobsSuccess,
      (state: NewOpportunitySimilarJobsState, { jobs }): NewOpportunitySimilarJobsState => ({
            ...state,
            jobs,
            showMore: false,
            loading: LoadingState.LOADED,
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.searchSimilarJobsError,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            jobs: [],
            loading: LoadingState.LOADED,
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.similarJobsPermissionDenied,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            jobs: [],
            loading: LoadingState.LOADED,
            permissionDenied: true,
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.similarJobsCleared,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            jobs: [],
            loading: LoadingState.INIT,
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.discardChangesDialogOpened,
      (state: NewOpportunitySimilarJobsState, { jobId, zoneId, changes }): NewOpportunitySimilarJobsState => ({
            ...state,
            continueJobConfirmDialog: {
                ...newOpportunitySimilarJobsInitialState.continueJobConfirmDialog,
                visible: true,
                jobId,
                zoneId,
                changes,
            },
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.doNotAskAgainChanged,
      (state: NewOpportunitySimilarJobsState, { checked }): NewOpportunitySimilarJobsState => ({
            ...state,
            continueJobConfirmDialog: {
                ...state.continueJobConfirmDialog,
                doNotAskAgain: checked,
            },
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.discardChangesDialogClosed,
      NewOpportunitySimilarJobsActions.discardChangesDialogConfirmButtonClicked,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            continueJobConfirmDialog: {
                ...newOpportunitySimilarJobsInitialState.continueJobConfirmDialog,
            },
        }),
    ),
    on(
      NewOpportunitySimilarJobsActions.showMoreClicked,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            showMore: !state.showMore,
        }),
    ),
    on(
      NewOpportunityCustomerActions.fullNameInputChanged,
      NewOpportunityCustomerActions.emailInputChanged,
      NewOpportunityCustomerActions.phoneInputChanged,
      NewOpportunityCustomerActions.companyInputChanged,
      (state: NewOpportunitySimilarJobsState, { value }): NewOpportunitySimilarJobsState => ({
            ...state,
            query: value,
        }),
    ),
    on(
      NewOpportunityCustomerActions.additionalContactFieldChanged,
      (state: NewOpportunitySimilarJobsState, { value }): NewOpportunitySimilarJobsState => ({
            ...state,
            query: value,
        }),
    ),
    on(
      NewOpportunityCustomerActions.existingCustomerSelected,
      (state: NewOpportunitySimilarJobsState): NewOpportunitySimilarJobsState => ({
            ...state,
            query: '',
        }),
    ),
    on(routerNavigatedAction, (
      state: NewOpportunitySimilarJobsState,
      { payload: { event: { urlAfterRedirects } } },
    ): NewOpportunitySimilarJobsState => {
      if (urlAfterRedirects.startsWith('/jobs/new') || /^\/jobs\/[^/]+\/edit/.test(urlAfterRedirects)) {
        return newOpportunitySimilarJobsInitialState;
      }
      return state;
    }),
];
